import axios from "axios";

class DashBoardDataService {
    getKPIs = (categoryId, filterValue) => {
        return axios.get(`/api/home/category/${categoryId}/kpis?filterType=${filterValue}`);
    };
     getTasks = () => {
        return axios.get(`/api/home/tasks`);
    };
    getReqWfChart = (filterValue) => {
        return axios.get(`api/home/reqworkflowchart?filterType=${filterValue}`);
    };
    getReqWfChartData = (filterValue) => {
        return axios.get(`api/home/reqworkflowchart/excel?filterType=${filterValue}`);
    };
    getCandWfChart = (filterValue) => {
        return axios.get(`api/home/candworkflowchart?filterType=${filterValue}`);
    };
    getCandWfChartData = (filterValue) => {
        return axios.get(`api/home/candworkflowchart/excel?filterType=${filterValue}`);
    };
    postSequence = (data) => {
        return axios.post(`api/home/dashboard/user/map`, JSON.stringify(data));
    }
    putSequence = (dashboardVitalsUserMapId, data) => {
        return axios.put(`api/home/dashboard/user/map/${dashboardVitalsUserMapId}`, JSON.stringify(data));
    }
    getKpiExcel = (kpiId, filterType, kpiCode, queryStr) => {
        return axios.get(`/api/home/kpi/${kpiId}/details/data?filterType=${filterType}&kpiCode=${kpiCode}&${queryStr}`);
    }
    getTasksExcel = (taskTypeId, queryStr) => {
        return axios.get(`api/home/tasks/${taskTypeId}/details?${queryStr}`);
    }
}

export default new DashBoardDataService();